import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-about-zenoffice',
	templateUrl: './about-zenoffice.component.html',
	styleUrls: ['./about-zenoffice.component.scss'],
})
export class AboutZenofficeComponent implements OnInit {
	constructor() {
		//no content
	}

	ngOnInit(): void {
		//no content
	}
}
